





























































import { Vue, Component } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import {
    CheckVerificationEmail,
    ResendVerificationRequest,
} from '../shared/dtos';
import { client } from '../shared';
import { Routes, redirect } from '../shared/router';
import { Validations } from 'vuelidate-property-decorators';

@Component({
    mixins: [validationMixin],
})
export class Resend extends Vue {
    $v: any;
    form: any = {
        email: null,
    };

    @Validations()
    validations: any = {
        form: {
            email: {
                required,
                email,
                async isVerified(value: string) {
                    if (!value) {
                        return true;
                    }
                    try {
                        const res = await client.get(new CheckVerificationEmail({ email: value }));
                        return res.result === false;
                    } catch {
                        return true;
                    }
                },
            },
        },
    };

    async submit() {
        try {
            await client.post(
                new ResendVerificationRequest({ Email: this.form.email }),
            );
            this.$swal(
                'Verification email has been resent.',
                'Please check your inbox and follow the instructions in the email to complete your registration.',
                'success',
            ).then(() => {
                redirect(Routes.SignIn);
            });
        } catch (error) {
            this.$swal(
                'Email Not Found',
                'We could not find the email address you provided. Please check and try again.',
                'error',
            ).then(() => {
                redirect(Routes.SignIn);
            });
        }
    }
}

export default Resend;
